import { Pipe } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({name: 'localdate'})
export class LocalDatePipe extends DatePipe {
  transform(value: any, pattern: string = 'Australia/Sydney'): string|null {
    let datestr = super.transform(value, 'EEEE, d MMMM y hh:mm:ss');
    if (datestr == null) {
      return null;
    }
    datestr = datestr + ' GMT';
    let date = new Date(datestr);
    
    return date.toLocaleString('en-us', {timeZone:pattern});
  }
}